// extracted by mini-css-extract-plugin
export default {"minimalistBox":"House_minimalistBox__gNwRO","title":"House_title__TcEY+","description":"House_description__fudBG"};